const Breadcrumb = ({ title, children }: { title?: any; children?: any }) => {
  return (
    <div className=" px-7 w-full items-center my-2">
      <div className="flex justify-between">
        <div className="">
          {title && (
            <h1 className="text-base xl:text-xl font-bold w-full">{title}</h1>
          )}
        </div>
        {children ? (
          <div className="w-full text-center text-base xl:text-xl font-bold">
            {children}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Breadcrumb;
